import { api } from "./client";

export type EmailTemplateVariable = {
  name: string;
  fake: string;
  description: string;
};

/**
 * The variable catalog, owned by the infrastructure shared layer and served by
 * the support backend. Deliberately NOT restated anywhere in this app: a local
 * copy is what drifted from the senders in the first place.
 */
export type EmailTemplateVocabulary = {
  variables: EmailTemplateVariable[];
  base: string[];
  /** template name -> the variable names that template actually receives */
  templates: Record<string, string[]>;
};

export const EmailTemplateVarsApi = {
  get() {
    return api
      .get<EmailTemplateVocabulary>("/email-templates/variables")
      .then((r) => r.data);
  },
};

/**
 * Variable names delivered to `templateName`. An unrecognized name resolves to
 * the base set -- true by construction, because the bulk sender enqueues no
 * per-event context at all.
 */
export function variableNamesFor(
  vocab: EmailTemplateVocabulary,
  templateName: string | null | undefined,
): string[] {
  if (!templateName) return vocab.base;
  // `templates` came from JSON.parse, so it inherits Object.prototype: a
  // user-typed name like "constructor" or "toString" resolves to a function
  // via the prototype chain, and `??` doesn't fire for a truthy function.
  // hasOwnProperty guards against that.
  return Object.prototype.hasOwnProperty.call(vocab.templates, templateName)
    ? vocab.templates[templateName]
    : vocab.base;
}
